import { baseFCMNotification } from "../../../../api/base/baseUrl";

export async function sendBookingDriverNotificationRequest(payload) {
  try {
    const response = await baseFCMNotification.post(
      "/api/v1/booking/driver/assign",
      payload,
      { headers: { "Content-Type": "application/json" } },
    );

    return { success: true, data: response.data.data, error: null };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "La reserva fue asignada, pero no se pudo enviar la notificacion",
    };
  }
}
